import { Grid, Card, CardContent, Typography } from '@material-ui/core';
import React from 'react';
import { useHistory } from 'react-router';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import SearchBox from '../../../components/table/SearchBox';

const useStyles = makeStyles((theme) => ({
    // root: {
    //     margin: '0',
    // },
    button: {
        // margin: '10px 0px 5px !important',
        width: '155px',
        fontSize: '15px !important',
        fontWeight: '400 !important',
        borderRadius: '6px',
        textTransform: 'capitalize',
        padding: '6px 10px',
        letterSpacing: 'normal',
    },
}));
const ServiceLayout = ({ title = 'Title', searchQuery, onChange, children, className, service, clearField }) => {
    const history = useHistory();
    const classes = useStyles();

    const navigate = () => {
        history.push('/menu/service');
    };
    return (
        <>
            <Card className="custom-table">
                <CardContent className="card-title-display">
                    <Grid item xs={12} sm={8}>
                        <Typography className="card-title">{title}</Typography>
                    </Grid>
                    {/* <Grid item xs={12} sm={6} className="card-search">
                        <div className="search-field">
                            <SearchBox searchQuery={searchQuery} onChange={onChange} placeholder="Search..." />
                        </div>
                        {service !== 'ultimateopen'  ? (
                            <div className="card-add-button">
                                <Button variant="outlined" color="primary" size="small" onClick={navigate} className={classes.button}>
                                    Create service
                                </Button>
                            </div>
                        ) : (
                            <div style={{ width: '0%' }} />
                        )}
                    </Grid> */}
                    {/* Removing Create Service button under Closed Services screen */}
                    <Grid item xs={12} sm={6} className="card-search">
                        <div className="search-field">
                            <SearchBox searchQuery={searchQuery} onChange={onChange} placeholder="Search..." clearField={clearField} />
                        </div>
                        {service === 'open'  ? (
                            <div className="card-add-button">
                                <Button variant="outlined" color="primary" size="small" onClick={navigate} className={classes.button}>
                                    Create service
                                </Button>
                            </div>
                        ) : (
                            <div style={{ width: '0%' }} />
                        )}
                    </Grid>
                </CardContent>
                <CardContent className="card-table-display">{children}</CardContent>
            </Card>

            {/* <div style={{ display: 'flex', background: 'white', padding: '14px' }}>
                <div style={{ paddingTop: '10px' }}>
                    <h5 className="openservice-title">{title}</h5>
                </div>
                <div className="serachDiv" container style={{ marginLeft: '27%', width: '41%' }}>
                    <SearchBox searchQuery={searchQuery} onChange={onChange} placeholder="Search..." />
                </div>
                {service !== 'ultimateopen' ? (
                    <div style={{ marginLeft: '4%', width: '12%' }}>
                        <button className="createservice-btn" onClick={navigate}>
                            Create service
                        </button>
                    </div>
                ) : (
                    <div style={{ width: '0%' }} />
                )}
            </div>
            <div>{children}</div> */}
        </>
    );
};

export default ServiceLayout;
